module.exports = __webpack_public_path__ + "img/happy_w001.a64d4e1a.jpg";